import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { FundraiserForm } from './FundraiserForm';
import { FundraiserForm as FundraiserFormV2 } from './v2/FundraiserForm';
import { Fundraisers } from './Fundraisers';
import Registrations from './Registrations';

export const FundraiserIndex = () => {
  return (
    <Switch>
      <Route exact path='/fundraisers' component={Fundraisers} />
      <Route exact path='/fundraisers/add' component={FundraiserForm} />
      <Route exact path='/fundraisers/edit/:id' component={FundraiserForm} />
      <Route
        exact
        path='/fundraisers/registrations/:id'
        component={Registrations}
      />
      {/*
        The v2 routes are always registered, even when the beta flag is off, so a
        client handed the direct URL can reach the form during a demo. Discovery
        stays gated by `fundraiserV2Enabled` (sidebar link, "Add Fundraiser"), so
        nobody lands here without being sent. This also keeps `getEditUrl()` in
        Fundraisers.tsx honest — it routes by `form_version`, not by the flag, so
        an existing v2 fundraiser must have somewhere to open.
      */}
      <Route exact path='/fundraisers/v2/add' component={FundraiserFormV2} />
      <Route exact path='/fundraisers/v2/edit/:id' component={FundraiserFormV2} />
    </Switch>
  );
};
